/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesFriendCategorySchema = z.enum([
  "None",
  "Teammate",
  "Acquaintance",
  "Favorite",
]);
